export enum ApiEndpoints {
  ACCOUNT_AUTHENTICATED_USER = '/my/account/authenticated-user',
}
